export const SlbServicesPlpPageTemplate = {
  slots: ['SlbServicesPlpSlot'],
};
